import React from "react";
import { Spin } from "antd";

const WEBVIEW_BASE_URL = "https://agent.apilingua.com/index.html";

interface Props {
    aiLoading: boolean;
    aiSession: any;
    iframeRef: React.RefObject<HTMLIFrameElement>;
}

const AiSpeakingAgent: React.FC<Props> = ({ aiLoading, aiSession, iframeRef }) => {

    const handleIframeLoad = () => {
        if (iframeRef.current && aiSession) {
            const win = iframeRef.current.contentWindow;
            if (win) {
                const configData = {
                    type: 'INIT_CONFIG',
                    payload: {
                        AI_INSTRUCTION: aiSession.instructions,
                        TOPIC_NAME: aiSession.topicName,
                        LEVEL_NAME: aiSession.levelName,
                        TOPIC_DESCRIPTION: aiSession.topicDesc
                    }
                };
                win.postMessage(configData, '*');
            }
        }
    };

    return (
        <div className="position-relative w-100" style={{ height: "650px", backgroundColor: "#0f172a", overflow: "hidden" }}>
            {aiLoading ? (
                <div className="d-flex flex-column justify-content-center align-items-center h-100 text-white">
                    <Spin size="large" />
                    <p className="mt-3">Initializing Whizzy...</p>
                </div>
            ) : aiSession ? (
                <iframe
                    ref={iframeRef}
                    src={`${WEBVIEW_BASE_URL}?ephemeral_key=${aiSession.client_secret.value}`}
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        position: "absolute",
                        top: 0,
                        left: 0
                    }}
                    allow="microphone"
                    onLoad={handleIframeLoad}
                    title="AI Speaking Agent"
                />
            ) : (
                <div className="d-flex justify-content-center align-items-center h-100 text-white">
                    <p>Error loading AI session or no session active.</p>
                </div>
            )}
        </div>
    );
};

export default AiSpeakingAgent;